var map = {
	"./badges/aws-certified-cloud-practitioner.png": 12,
	"./badges/aws-certified-solutions-architect-associate.png": 13,
	"./badges/azure-certified-solutions-architect.png": 14,
	"./badges/professional-scrum-master.png": 15,
	"./headerImage.png": 43,
	"./headerImage1.jpg": 44,
	"./headerImage2.png": 45,
	"./headerImageOriginal.jpg": 46,
	"./loader.gif": 47,
	"./overlay-bg.png": 48,
	"./portfolio/ai-boat-project-pcb-boat.png": 16,
	"./portfolio/ai-boat-project-pcb.png": 17,
	"./portfolio/ai-boat-project.jpg": 18,
	"./portfolio/demographics-mapping.png": 19,
	"./portfolio/geoso-website.png": 20,
	"./portfolio/local-news-backend.png": 21,
	"./portfolio/local-news-mobile.png": 22,
	"./portfolio/multirotor-aircraft.jpg": 23,
	"./profilepic.jpg": 49
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 42;